import 'moment/locale/en-gb';
import 'moment/locale/en-au';
import 'moment/locale/he';
import { antd_en_US, antd_he_IL } from '@jjj/components';

export default {
  antd: {
    en_US: antd_en_US,
    en_AU: antd_en_US,
    he_IL: antd_he_IL,
    en_GB: antd_en_US,
  },
};
